import { render, staticRenderFns } from "./WrittenWordType.vue?vue&type=template&id=865c07c6&scoped=true&"
import script from "./WrittenWordType.vue?vue&type=script&lang=js&"
export * from "./WrittenWordType.vue?vue&type=script&lang=js&"
import style0 from "./WrittenWordType.vue?vue&type=style&index=0&id=865c07c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865c07c6",
  null
  
)

export default component.exports